import { useCollectionPager } from 'framework/ViewTypes/hooks';
import type { PreviewPositionSlotListItem } from '../types';
import usePositionSlotsService from '../usePositionSlotsService';
import { buildPositionSlotsFilter } from './filterState';
import { CollectionViewParamsConfig } from 'framework/ViewTypes';
import { FilterState } from 'framework/ViewTypes/components';
import { FilterCondition } from 'framework/types';
import { DEFAULT_POSITION_SLOT_LIFECYCLE_FILTER } from '../constants';
import { DESC } from 'framework/list';
import { POSITION_SLOTS_STATE_VALIDATION } from './viewParamsValidation';

const POSITION_SLOTS_VIEW_PARAMS_CONFIG: CollectionViewParamsConfig<FilterState> = {
  ...POSITION_SLOTS_STATE_VALIDATION,
  defaultFilters: {
    lifecycle: { [FilterCondition.IN]: DEFAULT_POSITION_SLOT_LIFECYCLE_FILTER },
  },
  defaultSortBy: 'createdAt',
  defaultSortOrder: DESC,
  cache: true,
};

const usePositionSlotsCollection = () => {
  const { getPositionSlotsPage } = usePositionSlotsService();

  return useCollectionPager<PreviewPositionSlotListItem, FilterState>({
    pageSize: 30,
    viewParamsConfig: POSITION_SLOTS_VIEW_PARAMS_CONFIG,
    fetchPage: ({ pageNumber, pageSize, filters, searchValue, sort, signal }) =>
      getPositionSlotsPage(
        {
          pageNumber,
          pageSize,
          filter: buildPositionSlotsFilter(filters, searchValue),
          sort,
        },
        { signal },
      ),
  });
};

export default usePositionSlotsCollection;
